export const LOAD_USER = 'AUTH/LOAD_USER';

export const INIT = 'AUTH/INIT';
export const INIT_SUCCESS = 'AUTH/INIT/SUCCESS';
export const INIT_ERROR = 'AUTH/INIT/ERROR';

export const LOGIN = 'AUTH/LOGIN/LOGIN';
export const LOGIN_SUCCESS = 'AUTH/LOGIN/SUCCESS';
export const LOGIN_ERROR = 'AUTH/LOGIN/ERROR';

export const LOGOUT = 'AUTH/LOGOUT/LOGOUT';
export const LOGOUT_SUCCESS = 'AUTH/LOGOUT/SUCCESS';
export const LOGOUT_ERROR = 'AUTH/LOGOUT/ERROR';

export const loadUser = () => ({
  type: LOAD_USER,
});

export const init = () => ({
  type: INIT,
});

export const initSuccess = ({ salt }) => ({
  type: INIT_SUCCESS,
  salt,
});

export const initError = () => ({
  type: INIT_ERROR,
});

export const login = credentials => ({
  type: LOGIN,
  credentials,
});

export const loginSuccess = ({ user, salt }) => ({
  type: LOGIN_SUCCESS,
  user,
  salt,
});

export const loginError = ({ response }) => ({
  type: LOGIN_ERROR,
  error: response,
});

export const logout = () => ({
  type: LOGOUT,
});

export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS,
});

export const logoutError = ({ response }) => ({
  type: LOGOUT_ERROR,
  error: response,
});
